import { makeStyles } from "@material-ui/core";
import colors from "Styles/colors";

const useStyles = makeStyles(({ spacing, palette }) => ({
  gridWrapper: {
    marginRight: spacing(4),
    "&:last-child": {
      marginRight: 0,
    },
    padding: "0 !important",
  },
  card: {
    padding: 24,
    minWidth: 240,
    maxHeight: 165,
  },
  title: {
    color: colors.black,
    fontWeight: 600,
  },
  value: {
    fontSize: 32,
    marginRight: 16,
    fontWeight: 600,
  },
  valueSuffix: {
    color: colors.black,
  },
  footer: {
    color: palette.grey[500],
  },
}));

export default useStyles;
